import { render, staticRenderFns } from "./StudentProgressTable.vue?vue&type=template&id=c4d1cfce&scoped=true&lang=pug&"
import script from "./StudentProgressTable.vue?vue&type=script&lang=ts&"
export * from "./StudentProgressTable.vue?vue&type=script&lang=ts&"
import style0 from "./StudentProgressTable.vue?vue&type=style&index=0&id=c4d1cfce&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d1cfce",
  null
  
)

export default component.exports